module.exports = __webpack_public_path__ + "img/ellipse.82bedcf.png";